var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isDetail
        ? _c("el-input", {
            attrs: {
              placeholder: "用于展示关联表单的属性，且数据不会保存",
              readonly: "",
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          })
        : _c("p", [_vm._v(_vm._s(_vm.value))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }